import { Grid } from '@material-ui/core'
import React, { useContext } from 'react'
import { IndividualVideo } from './IndividualVideo'
import { AppContext } from '../../AppContext';

export const Layout4 = (props) => {
  const { isMobile } = useContext(AppContext);
  const getPadding = () => {
    return isMobile ? "15vw" : "10vw"
  }

  const getPadding2 = () => {
    return isMobile ? "15vw" : "2vw"
  }

  if(props.layout === 0) {
    return <div style={{ paddingRight: getPadding() , paddingLeft: getPadding() }}>
    <Grid container>
      {props.videoStreams.map(vs =>
        <Grid key={vs.assignedId} item sm={12} md={6} lg={6}>
          <IndividualVideo {...props} {...vs} />
        </Grid>
      )}
    </Grid>
  </div> 
  }
  return (
     <div style={{ paddingRight: getPadding2(), paddingLeft: getPadding2() }}>
      <Grid container>
        {props.videoStreams.map(vs =>
          <Grid key={vs.assignedId} item sm={12} md={3} lg={3}>
            <IndividualVideo {...props} {...vs} />
          </Grid>
        )}
      </Grid>
    </div>
  )
}
